import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchUsersTable() {
  yield takeLatest('offices/fetchTable', fetchTable);
}

function* watchFetchUserDetail() {
  yield takeLatest('offices/fetchDetail', fetchDetail);
}

function* watchSubmitUserDetail() {
  yield takeLatest('offices/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([fork(watchFetchUsersTable), fork(watchFetchUserDetail), fork(watchSubmitUserDetail)]);
}
